import Bugsnag from '@bugsnag/js';

const bugsnag = Bugsnag.start({
    apiKey: 'afb7ea98e0144614ba31260a293dd6c9',
    otherOptions: {
        appType: 'frontend-app'
    }
});

export default bugsnag;
